import { render, staticRenderFns } from "./classical-wom.vue?vue&type=template&id=3bd24cac"
import script from "./classical-wom.vue?vue&type=script&lang=js"
export * from "./classical-wom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports